import { BlockText, GridContainer, GridItem, ViewSection } from "@duosoftbg/nacid-components";

const AccountViewSection = ({ record }) => {
  return (
    <ViewSection label={"t.registration.details"}>
      <GridContainer spacing={3} mt={0}>
        <GridItem>
          <BlockText label={"l.user.username"} text={record.username} />
        </GridItem>
        <GridItem>
          <BlockText label={"l.person.email"} text={record.email} />
        </GridItem>
      </GridContainer>
    </ViewSection>
  );
};
export default AccountViewSection;
